
import React, { Component } from 'react';

import { Modal, ModalBody, Card, CardBody, Button, CardHeader } from 'reactstrap';
import ModifierItemDialogue from './ModifierItemDialogue'

var modifierDialogueUtil = require('../modifierDialogueUtil.js');
class WizardModifierDialogue extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};

        this.state.workflowState = [];

        var startingModifierIndex = 0;
        if (this.props.startingModifierIndex >= 0 &&
            this.props.startingModifierIndex < this.props.modifiersViewModels.length)
        startingModifierIndex = this.props.startingModifierIndex;

        this.createNewWorkflowStage(this.props.modifiersViewModels[startingModifierIndex]);

        this.state.workflowStateHistory = [];
    }

    render()
    {
        var stage = this.peekStage();

        return  <ModifierItemDialogue 
                    modifierViewModel={stage.modifierViewModel} 
                    modifiersViewModels={this.props.modifiersViewModels}
                    previousAllowed = {this.state.workflowStateHistory.length > 0}
                    hideCancelButton = {this.props.hideCancelButton}
                    sale={this.props.sale}
                    menu={this.props.menu}
                    onCancel={()=>
                    {
                        this.props.onCancel();
                    }}
                    onPrevious={()=>
                    {
                        while (true)
                        {
                            if (this.state.workflowStateHistory.length == 0)
                                return;

                            this.state.workflowState = this.state.workflowStateHistory.pop();
                            
                            if (this.props.isNewOrderFlow && this.peekStage().modifierViewModel.underlyingModifier.hiddenInOrderFlow)
                                continue;

                            if (this.props.isNewOrderFlow && modifierDialogueUtil.isModifierSystemAutoSelected(this.peekStage().modifierViewModel.underlyingModifier))
                                continue;

                            this.setState({});
                            break;
                        }
                        
                    }}
                    onNext={()=>
                    {
                        while (true)
                        {
                            this.captureHistory();
                            this.chooseNextModifier();
    
                            if (this.peekStage() == null)
                            {
                                this.props.onSave(this.props.modifiersViewModels);
                                return;
                            }

                            if (this.props.isNewOrderFlow && this.peekStage().modifierViewModel.underlyingModifier.hiddenInOrderFlow)
                                continue;

                            if (this.props.isNewOrderFlow && modifierDialogueUtil.isModifierSystemAutoSelected(this.peekStage().modifierViewModel.underlyingModifier))
                                continue;
    
                            this.setState({});
                            break;
                        }
                    }}
                    onSave={()=>
                    {
                        this.props.onSave(this.props.modifiersViewModels);
                    }}/>
    }

    chooseNextModifier()
    {
        var stage = this.peekStage();
        if (stage == null)
            return;

        var modifierViewModel = stage.modifierViewModel;

        if (stage.itemIndex+1 < modifierViewModel.items.length)
        {
            stage.itemIndex = stage.itemIndex + 1;
            var modifierItemViewModel = modifierViewModel.items[stage.itemIndex];

            if (modifierItemViewModel.quantity <= 0 || modifierItemViewModel.modifiersViewModels.length <= 0)
            {
                this.chooseNextModifier();
                return;
            }
            else
            {
                this.createNewWorkflowStage(modifierViewModel.items[stage.itemIndex].modifiersViewModels[0]);
                return;
            }
        }

        this.popStage();
        if (stage.modifierViewModel.nextSibling != null)
        {
            this.createNewWorkflowStage(stage.modifierViewModel.nextSibling);
            return;
        }
   
        this.chooseNextModifier();
    }

    peekStage()
    {
        if (this.state.workflowState == null)
            return null;

        return this.state.workflowState[this.state.workflowState.length-1]
    }

    popStage()
    {
        if (this.state.workflowState == null)
            return null;

        return this.state.workflowState.pop();
    }


    createNewWorkflowStage(modifierViewModel)
    {
        var stage = {};
        stage.modifierViewModel = modifierViewModel;
        stage.itemIndex = -1;
        this.state.workflowState.push(stage);
    }
    
    captureHistory()
    {
        var currentWorkflowState = [];

        this.state.workflowState.forEach (stage =>
        {
            var clonedStage = {};
            clonedStage.modifierViewModel = stage.modifierViewModel;
            clonedStage.itemIndex = stage.itemIndex;
            currentWorkflowState.push(clonedStage);
        });

        this.state.workflowStateHistory.push(currentWorkflowState);
    }

}

export default WizardModifierDialogue